import Checkbox from '@/components/Checkbox';
import Loading from '@/components/Loading';
import { Tag } from '@/components/Tag';
import type { CustomFieldFieldType, SharedCustomField } from '@/types/serializers';

type Props = {
  customFields: SharedCustomField[];
  selectedIds: Record<string, boolean>;
  isAllSelected: boolean;
  isSomeSelected: boolean;
  isLoading: boolean;
  isError: boolean;
  onToggleAll: (checked: boolean) => void;
  onToggleOne: (id: number, checked: boolean) => void;
};

const getFieldTypeLabel = (fieldType: CustomFieldFieldType): string => {
  switch (fieldType) {
    case 'short_text':
      return 'テキスト';
    case 'long_text':
      return 'テキストエリア';
    case 'single_select':
      return 'セレクトボックス';
    case 'multiple_select':
      return '複数選択';
    case 'number':
      return '数値';
    case 'date':
      return '日付';
    case 'datetime':
      return '日時';
    default:
      return '不明';
  }
};

export default function AddItemCandidateItems({
  customFields,
  selectedIds,
  isAllSelected,
  isSomeSelected,
  isLoading,
  isError,
  onToggleAll,
  onToggleOne,
}: Props) {
  return (
    <div className="rounded-sm border border-solid border-border">
      {isLoading ? (
        <div className="flex h-[220px] items-center justify-center">
          <Loading size="small" />
        </div>
      ) : isError ? (
        <div className="flex h-[220px] items-center justify-center px-4">
          <span className="text-xs text-danger">カスタム項目の取得に失敗しました。</span>
        </div>
      ) : customFields.length === 0 ? (
        <div className="flex h-[220px] items-center justify-center px-4">
          <span className="text-xs text-sub">追加できる項目はありません。</span>
        </div>
      ) : (
        <table className="w-full border-collapse">
          <thead className="bg-gray_darken">
            <tr className="border-b border-solid border-border">
              <th className="w-12 border-r border-solid border-border text-center">
                <div className="flex h-12 items-center justify-center">
                  <Checkbox
                    checked={isAllSelected}
                    indeterminate={isSomeSelected}
                    onChange={onToggleAll}
                  />
                </div>
              </th>
              <th className="h-12 border-r border-solid border-border px-md text-left text-body-md font-normal text-sub">
                項目名
              </th>
              <th className="h-12 px-md text-left text-body-md font-normal text-sub">情報タイプ</th>
            </tr>
          </thead>
          <tbody>
            {customFields.map((f) => (
              <tr key={f.id} className="border-b border-solid border-border">
                <td className="w-12 border-r border-solid border-border">
                  <div className="flex h-12 items-center justify-center">
                    <Checkbox
                      checked={Boolean(selectedIds[String(f.id)])}
                      onChange={(checked) => onToggleOne(f.id, checked)}
                    />
                  </div>
                </td>
                <td className="border-r border-solid border-border p-0">
                  <button
                    type="button"
                    className="flex h-12 w-full cursor-pointer items-center border-none bg-transparent px-md text-left text-body-md text-main hover:opacity-80"
                    onClick={() => onToggleOne(f.id, !selectedIds[String(f.id)])}
                    aria-label={`${f.name} を選択`}
                  >
                    {f.name}
                  </button>
                </td>
                <td className="p-0">
                  <button
                    type="button"
                    className="flex h-12 w-full cursor-pointer items-center border-none bg-transparent px-md text-left hover:opacity-80"
                    onClick={() => onToggleOne(f.id, !selectedIds[String(f.id)])}
                    aria-label={`${f.name} を選択`}
                  >
                    <Tag color="gray" size="md">
                      <span className="text-tag-sm">{getFieldTypeLabel(f.field_type)}</span>
                    </Tag>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
